import * as React from "react"
import { connect } from "react-redux"
import trans from "trans"

import { FindSimilarType } from "../types";
import { AxiosResponse } from "axios";
import { visualSimilarityFullExportFindSimilar } from "app/helpers/api";
import { IconSimilarity } from "app/icons";
import { Spinner } from "@bdfx/mergado-ui-kit";
import { initialFindSimilarState, setFindSimilar } from "products/reducer";

interface Props {
    imageHash: string
    findSimilar: FindSimilarType
    setFindSimilar: typeof setFindSimilar
}

interface State {
    isStartingJob: boolean
}

class FindSimilarButton extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            isStartingJob: null,
        }
    }

    handleFindSimilar = () => {
        const { findSimilar, imageHash } = this.props

        if (!findSimilar.isExporting) {
            this.props.setFindSimilar({ ...initialFindSimilarState })

            this.setState({ isStartingJob: true })

            visualSimilarityFullExportFindSimilar(imageHash)
                .then((response: AxiosResponse<any>) => {
                    console.debug('full export started')
                })
                .catch(e => console.error('cannot create full export', e))
                .finally(() => this.setState({ isStartingJob: false }))
        }
    }

    render() {
        const {isStartingJob} = this.state
        const { findSimilar, imageHash } = this.props
        const isLoading = findSimilar.isExporting || findSimilar.isSearching || isStartingJob

        return <React.Fragment>
            <span className={'clickable'} title={trans('find_similar_images')} onClick={this.handleFindSimilar}>
                {isLoading ? <Spinner /> : <IconSimilarity size={18} />}
            </span>
        </React.Fragment>
    }
}

function mapStateToProps(state) {
    return {
        findSimilar: state.findSimilar,
    }
}

export default connect(mapStateToProps, {
    setFindSimilar,
})(FindSimilarButton)

